var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 8 } },
            [
              _c("uploadImagetow", {
                ref: "uploadImagetow",
                attrs: {
                  paramsData: _vm.upData,
                  filesname: "item_file",
                  Url: "/hjhd-gm/uploadBagItemFile",
                  title: "批量上传"
                },
                on: {
                  change: function($event) {
                    return _vm.Refresh(1)
                  }
                }
              }),
              _c(
                "el-button",
                {
                  staticClass: "marginL",
                  attrs: { type: "primary" },
                  on: { click: _vm.exportdata }
                },
                [_vm._v("导出")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "marginL",
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("刷新")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "150" }
          }),
          _c("el-table-column", {
            attrs: { prop: "item_id", label: "道具ID" }
          }),
          _c("el-table-column", { attrs: { prop: "item_name", label: "名称" } })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.currentPage,
          total: _vm.tableCopyTableList.length,
          "page-size": _vm.pageSize
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }